import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/api';

export const fetchPhoneNumbers = createAsyncThunk(
  'phoneNumbers/fetchAll',
  async (wabaId, { rejectWithValue }) => {
    try {
      const response = await apiService.whatsapp.getPhoneNumbers(wabaId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPhoneNumberById = createAsyncThunk(
  'phoneNumbers/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.phoneNumbers.getById(id);
      return response.data || response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePhoneNumberQualityAsync = createAsyncThunk(
  'phoneNumbers/updateQuality',
  async ({ id, qualityRating }, { rejectWithValue }) => {
    try {
      const response = await apiService.phoneNumbers.updateQuality(id, qualityRating);
      return response.data || { id, qualityRating };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  phoneNumbers: [],
  loading: false,
  selectedPhoneNumber: null,
  loadingSelected: false,
  updateQualityLoading: false,
  error: null,
};

const phoneNumbersSlice = createSlice({
  name: 'phoneNumbers',
  initialState,
  reducers: {
    updatePhoneNumberQuality: (state, action) => {
      const { id, qualityRating } = action.payload;
      const phoneNumber = state.phoneNumbers.find(p => p.id === id);
      if (phoneNumber) {
        phoneNumber.qualityRating = qualityRating;
      }
      if (state.selectedPhoneNumber && state.selectedPhoneNumber.id === id) {
        state.selectedPhoneNumber.qualityRating = qualityRating;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneNumbers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPhoneNumbers.fulfilled, (state, action) => {
        state.loading = false;
        state.phoneNumbers = action.payload.data || action.payload;
      })
      .addCase(fetchPhoneNumbers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchPhoneNumberById.pending, (state) => {
        state.loadingSelected = true;
      })
      .addCase(fetchPhoneNumberById.fulfilled, (state, action) => {
        state.loadingSelected = false;
        state.selectedPhoneNumber = action.payload.data || action.payload;
      })
      .addCase(fetchPhoneNumberById.rejected, (state, action) => {
        state.loadingSelected = false;
        state.error = action.payload;
      })

      .addCase(updatePhoneNumberQualityAsync.pending, (state) => {
        state.updateQualityLoading = true;
      })
      .addCase(updatePhoneNumberQualityAsync.fulfilled, (state, action) => {
        state.updateQualityLoading = false;
        const payload = action.payload;
        const id = payload.id || (payload.data && payload.data.id);
        const qualityRating = payload.qualityRating || (payload.data && payload.data.qualityRating);
        if (id) {
          const phone = state.phoneNumbers.find(p => p.id === id);
          if (phone) phone.qualityRating = qualityRating;
          if (state.selectedPhoneNumber && state.selectedPhoneNumber.id === id) {
            state.selectedPhoneNumber.qualityRating = qualityRating;
          }
        }
      })
      .addCase(updatePhoneNumberQualityAsync.rejected, (state, action) => {
        state.updateQualityLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updatePhoneNumberQuality, clearError } = phoneNumbersSlice.actions;
export default phoneNumbersSlice.reducer;

